type BreadCrumb = { title: string; url: string };

type BreadCrumbMarkup = {
  breadcrumbs: BreadCrumb[];
  origin: string;
};

export const generateBreadCrumbsMarkup = ({ breadcrumbs, origin }: BreadCrumbMarkup) => ({
  '@context': 'https://schema.org',
  '@type': 'BreadcrumbList',
  itemListElement: breadcrumbs.map(({ title, url }, index) => {
    const isLast = index === breadcrumbs.length - 1;
    const crumb = {
      '@type': 'ListItem',
      position: index + 1,
      name: title,
    };

    return isLast ? crumb : { ...crumb, item: origin + url };
  }),
});
